import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Log from '../views/log.vue'
import Mistake from '../views/Mistake.vue'
import Masterpieces from "@/views/Masterpieces";
import Responsibility from "@/views/Responsibility";
import Check from "@/views/Check";
import Handle from "@/views/Handle";
import Calibration from "@/views/Calibration";
import Menu from "@/components/Menu";
import axios from "axios";
import NoPer from "@/views/NoPer";
import Layout from "@/components/Layout";


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Menu',  // 改为 'Layout' 作为根路由
    component: Menu,  // 引入一个新的 Layout 组件来包装 Menu
    redirect: '/HomeView',
    children: [
      {
        path: 'HomeView',
        name: 'HomeView',
        component: HomeView,
      },
      {
        path: 'Responsibility',
        name: 'Responsibility',
        component: Responsibility,
      },
      {
        path: 'Masterpieces',
        name: 'Masterpieces',
        component: Masterpieces,
      },
      {
        path: 'Check',
        name: 'Check',
        component: Check,
      },
      {
        path: 'handle',
        name: 'handle',
        component: Handle,
      },
      {
        path: 'mistake',
        name: 'mistake',
        component: Mistake,
      },
      {
        path: 'record',
        name: 'Calibration',
        component: Calibration,
      },
    ],
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index'),
  },
  {
    path: '/NoPer',
    name: 'NoPer',
    component: NoPer,
  },

];



const router = new VueRouter({
  routes,
})

function inWhiteList(toPath) {
  const whiteList = ['/login', '/NoPer']
  const path = whiteList.find((value) => {
    // 使用正则匹配
    const reg = new RegExp('^' + value)
    return reg.test(toPath)
  })
  return !!path
}

// router.beforeEach(async (to, from, next) => {
//   const urlParams = new URLSearchParams(window.location.search);
//   const token = urlParams.get('token');
//
//   if (inWhiteList(to.path)) {
//     next();
//   } else if (!token) {
//     next('/login');
//   } else {
//     try {
//       const response = await axios.get(`https://test.api.dzplus.dzng.cc/gateway/authorization/manage/user/get/info/by/token?token=${token}`);
//       const userPermissions = response.data.data.funcKeys;
//       const requiredPermissions = ["data_analysis_business_number_account_select", "data_analysis_business_number_name_select", "data_analysis_business_number_report_select", "data_analysis_business_number_prompt_select", "data_analysis_business_number_change_select", "data_analysis_business_number_record_select"];
//       const hasPermission = userPermissions.some(permission => requiredPermissions.includes(permission));
//
//       if (response.data.code === 500 || response.data.code === 502) {
//         next('/login');
//       } else if (!hasPermission) {
//         next('/NoPer');
//       } else {
//         sessionStorage.setItem('userName', response.data.data.userName);
//         sessionStorage.setItem("token", token);
//         next();
//       }
//     } catch (error) {
//       console.error("Error fetching user info:", error);
//       next('/login');
//     }
//   }
// });
router.beforeEach(async (to, from, next) => {
  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get('token');

  if (inWhiteList(to.path)) {
    // 路径在白名单中，直接放行
    next();
  } else if (!token) {
    // 未提供 token，跳转至登录页
    next('/login');
  } else {
    try {
      const response = await axios.get(`https://api.dzplus.dzng.com/gateway/authorization/manage/user/get/info/by/token?token=${token}`);
      // const response = await axios.get(`https://test.api.dzplus.dzng.cc/gateway/authorization/manage/user/get/info/by/token?token=${token}`);

      if (response.data.code === 500 || response.data.code === 502) {
        // 服务异常，跳转至登录页
        next('/login');
        return;
      }

      const userPermissions = response.data.data.funcKeys;
      const requiredPermissions = {
        '/HomeView': 'data_analysis_business_number_account_select',
        '/Responsibility': 'data_analysis_business_number_name_select',
        '/Masterpieces': 'data_analysis_business_number_report_select',
        '/Check': 'data_analysis_business_number_prompt_select',
        '/handle': 'data_analysis_business_number_change_select',
        '/mistake': 'data_analysis_business_number_record_select',
        '/record': 'data_analysis_business_number_wrong_select'

      };

      sessionStorage.setItem('userName', response.data.data.userName);
      sessionStorage.setItem('token', token);

      // 判断用户是否有权限访问目标路径
      const hasPermission = (path) => {
        const requiredPermission = requiredPermissions[path];
        return requiredPermission ? userPermissions.includes(requiredPermission) : true;
      };

      // 如果访问的是 /HomeView 且没有权限
      if (to.path === '/HomeView' && !hasPermission('/HomeView')) {
        const allowedRoute = Object.keys(requiredPermissions).find((route) =>
            hasPermission(route)
        );

        if (allowedRoute) {
          next(allowedRoute); // 跳转到用户有权限的页面
        } else {
          next('/NoPer'); // 用户无任何页面权限
        }
      } else if (to.path === '/' || !hasPermission(to.path)) {
        // 如果访问根路径 '/' 或其他无权限页面
        const allowedRoute = Object.keys(requiredPermissions).find((route) =>
            hasPermission(route)
        );

        if (allowedRoute) {
          next(allowedRoute); // 跳转到用户有权限的页面
        } else {
          next('/NoPer'); // 用户无任何页面权限
        }
      } else {
        next(); // 用户有权限访问目标页面，继续导航
      }
    } catch (error) {
      console.error("Error fetching user info:", error);
      next('/login'); // 异常情况跳转至登录页
    }
  }
});






export default router